<template>
    <div class="container-fluid">
    <br />
    <b-row>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-pencil"></i> Fontes
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="fonts">
              <li v-for="font in fonts" :key="font" class="list-group-item">{{font}} <b-button @click="removeFont(font)" variant="danger"><i class="fa fa-trash"/></b-button></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-pencil"></i> Fontes
          </div>
          <div class="card-body">
            <b-input-group class="mb-3">
              <b-form-input
                type="text"
                class="form-control"
                placeholder="Digite o nome exato da fonte"
                v-model="fontToAdd"
              />
              <b-button @click="addFont()" variant="success"><i class="fa fa-plus"/></b-button>
            </b-input-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";
import CreationList from "./CreationList";

export default {
  name: 'AdminFonts',
  data: () => {
    return {
      fonts: [],
      fontToAdd: ""
    };
  },
  methods: {
    getFonts: function() {
      service.getFonts().then(response => {
        this.fonts = response.fonts;
      });
    },
    removeFont: function(font) {
      service.removeFont(font).then(response => {
        service.getFonts().then(response => {
          this.fonts = response.fonts;
        });
      });
    },
    addFont: function() {
      console.log("123321321");
      if (this.fontToAdd) {
        service.addFont(this.fontToAdd).then(response => {
          this.fontToAdd = "";
          service.getFonts().then(response => {
            this.fonts = response.fonts;
          });
        });
      }
      
    }
  },
  created() {
    this.getFonts();
  },
  components: { Spinner, CreationList }
}
</script>


